/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseDailyTrendResponse } from '../models/ApiResponseDailyTrendResponse';
import type { ApiResponseLatestScoreResponse } from '../models/ApiResponseLatestScoreResponse';
import type { ApiResponseMonthlyTrendResponse } from '../models/ApiResponseMonthlyTrendResponse';
import type { ApiResponseScoreByMonthResponse } from '../models/ApiResponseScoreByMonthResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class SafeDrivingService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * 안전운전점수 월별 추이
   * Monthly trend ( 안전운전점수 월별 추이 )
   * @returns ApiResponseMonthlyTrendResponse OK
   * @throws ApiError
   */
  public monthlyTrend1({
    vin,
  }: {
    vin: string,
  }): CancelablePromise<ApiResponseMonthlyTrendResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/safe-driving/monthlyTrend/{vin}',
      path: {
        'vin': vin,
      },
    });
  }
  /**
   * 월 안전운전 점수 상세
   * Score by month ( 월 안전운전 점수 상세 )
   * @returns ApiResponseScoreByMonthResponse OK
   * @throws ApiError
   */
  public scoreByMonth1({
    vin,
    month,
  }: {
    vin: string,
    month: string,
  }): CancelablePromise<ApiResponseScoreByMonthResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/safe-driving/monthlyDetail/{vin}',
      path: {
        'vin': vin,
      },
      query: {
        'month': month,
      },
    });
  }
  /**
   * 안전운전점수 조회
   * 안전운전점수 조회
   * @returns ApiResponseLatestScoreResponse OK
   * @throws ApiError
   */
  public latest({
    vin,
  }: {
    vin: string,
  }): CancelablePromise<ApiResponseLatestScoreResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/safe-driving/latest/{vin}',
      path: {
        'vin': vin,
      },
    });
  }
  /**
   * 일별 안전운전점수
   * Daily trend ( 일별 안전운전점수 )
   * @returns ApiResponseDailyTrendResponse OK
   * @throws ApiError
   */
  public dailyTrend1({
    vin,
    month,
  }: {
    vin: string,
    month: string,
  }): CancelablePromise<ApiResponseDailyTrendResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/safe-driving/dailyTrend/{vin}',
      path: {
        'vin': vin,
      },
      query: {
        'month': month,
      },
    });
  }
}
